import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, output, viewChild } from '@angular/core';
import { SplitterModule } from '@progress/kendo-angular-layout';
import { Subscription } from 'rxjs';
import { ProjectBaseScenarioTabItemComponent } from '../../project-base-scenario-tabitem.component';
import { ProjectScopingCapacitiesComponent } from '../components/project-scoping-capacities/project-scoping-capacities.component';
import { ProjectScopingCapitalComponent } from '../components/project-scoping-capital/project-scoping-capital.component';
import { ProjectScopingChartComponent } from '../components/project-scoping-chart/project-scoping-chart.component';
import { ProjectScopingItemsComponent } from '../components/project-scoping-items/project-scoping-items.component';
import { ProjectScopingBrokerService } from '../services/project-scoping-broker.service';
import { ProjectScopingService } from '../services/project-scoping.service';

@Component({
  selector: 'app-project-scoping-index',
  templateUrl: './project-scoping-index.component.html',
  styleUrls: ['./project-scoping-index.component.scss'],
  imports: [
    ProjectScopingCapacitiesComponent,
    ProjectScopingCapitalComponent,
    ProjectScopingChartComponent,
    ProjectScopingItemsComponent,
    SplitterModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    ProjectScopingBrokerService,
    ProjectScopingService,
  ],
})
export class ProjectScopingIndexComponent extends ProjectBaseScenarioTabItemComponent implements OnInit, OnDestroy {
  private broker = inject(ProjectScopingBrokerService);

  readonly tabTitle = output<string>();
  readonly tabTdv = output<boolean>();


  readonly projectScopingItemsComponent = viewChild(ProjectScopingItemsComponent);
  readonly projectScopingCapitalComponent = viewChild(ProjectScopingCapitalComponent);
  readonly projectScopingCapacitiesComponent = viewChild(ProjectScopingCapacitiesComponent);
  readonly projectScopingChartComponent = viewChild(ProjectScopingChartComponent);

  private itemsGridChangedEventSub: Subscription;
  private saveChangesSuccessfulEventSub: Subscription;

  constructor() {
    super();
  }

  ngOnInit() {
    this.itemsGridChangedEventSub = this.broker.ProjectScopingItemsGridChangedEvent.subscribe((s: any) => {
      this.handleItemsGridChangedEvent(s);
    });

    this.saveChangesSuccessfulEventSub = this.broker.SaveChangesSuccessfulEvent.subscribe((s: any) => {
      this.handleSaveChangesSuccessfulEvent(s);
    });
  }

  ngOnDestroy() {
    if (this.itemsGridChangedEventSub) {
      this.itemsGridChangedEventSub.unsubscribe();
    }
    if (this.saveChangesSuccessfulEventSub) {
      this.saveChangesSuccessfulEventSub.unsubscribe();
    }
  }

  private handleItemsGridChangedEvent(s) {
    if (!s) return;

    this.tabTdv.emit(true);
  }

  private handleSaveChangesSuccessfulEvent(s) {
    if (!s) return;

    this.tabTdv.emit(false);
  }

  public saveChanges(e: any) {
    this.broker.SaveChangesEvent.next(true);
  }

  public cancelChanges(e: any) {
    this.broker.CancelChangesEvent.next(true);
    this.tabTdv.emit(false);
  }

  public async runTabActivity() {
    await this.projectScopingItemsComponent().loadData();
    await this.projectScopingCapitalComponent().loadCapitalData();
    await this.projectScopingCapacitiesComponent().loadProjectCapacities();
    await this.projectScopingChartComponent().loadData();
  }
}